<template>
    <div>
        <div class="break-after width-100 relative m-b-md">
            <h3 class="card-title-text">Facebook preview</h3>
            <Toast width="expand" v-if="errors.msg" :variant="errors.status">{{errors.msg}}</Toast>
        </div>
        <Card>
            <div class="post-preview-wrap">
                <div class="post-preview-user-wrap">
                    <Avatar variant="social-preview"></Avatar>
                    <div class="post-preview-user-info">
                        <div class="post-preview-user-name">Cas van Grunsven</div>
                        <div class="post-preview-user-subinfo">5 minutes ago</div>
                    </div>
                </div>
                <div class="post-preview-content">
                    <p>{{post.text}}</p>
                </div>
                <div v-if="post.media.type === 'image'" class="post-preview-thumb facebook">
                  <img v-bind:src="post.media.url"/>
                </div>
                <div class="post-preview-dummies">
                    <div class="post-preview-dummy">
                        <svgicon name="thumb" /> Leuk
                    </div>
                    <div class="post-preview-dummy">
                        <svgicon name="comment" /> Commentaar
                    </div>
                    <div class="post-preview-dummy">
                        <svgicon name="share" /> Delen
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>
<script>
    import Toast from "../../../Toast/Toast";
    import Avatar from "../../../Avatar/Avatar";
    import Card from "../../../Card/Card";
    export default {
        name: 'Facebook',
        components: {
            Card,
            Avatar,
            Toast

        },
        props: ['post', 'errors'],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }
</script>
<style src="./Facebook.scss" scoped lang="scss"></style>
